import { formatDateTime } from "@/utils";
import ICON_CORNER from "@/assets/images/corner.svg";
import MatchMinute from "../KbvMatchMinute";

export default function MatchTime({
  homeCorner,
  awayCorner,
  isLive,
  isFinished,
  isNotStarted,
  matchTime,
  liveScore,
  status,
  halfStartTime,
  className,
  textAlignment = "center",
  cornerStacked = true,
  isHomeWin = false,
  isAwayWin = false,
  currentHomeScore = 0,
  currentAwayScore = 0,
}) {
  const layoutClass = cornerStacked
    ? "flex flex-col items-center gap-1"
    : "flex flex-row items-center justify-between mt-0.5";

  if (isFinished) {
    return (
      <div className={`${layoutClass} min-w-fit`}>
        <span className="text-sm whitespace-nowrap text-[var(--theme-text)]">Kết Thúc</span>
        <div className="flex items-center gap-1 whitespace-nowrap">
          <img src={ICON_CORNER} alt="corner" width={8} height={8} className="kbv-corner-icon" />
          <span className="text-sm text-[var(--theme-text)]">{homeCorner}:{awayCorner}</span>
        </div>
      </div>
    );
  }

  if (isNotStarted && matchTime) {
    const { date, time } = formatDateTime(matchTime);
    return (
      <div className="flex flex-col gap-1 min-w-fit whitespace-nowrap">
        <span className="text-sm font-semibold text-[var(--theme-text)]">{time}</span>
        <span className="text-sm text-[var(--theme-text)]">{date}</span>
      </div>
    );
  }

  if (isLive && matchTime) {
    return (
      <div
        className={`${layoutClass} min-w-fit whitespace-nowrap ${className || ""}`}
      >
        <MatchMinute
          liveScore={liveScore}
          status={status}
          matchTime={matchTime}
          halfStartTime={halfStartTime}
          className={`text-sm leading-[1.2] text-[var(--theme-primary)] text-${textAlignment}`}
        />
        <div className="items-center gap-1 whitespace-nowrap md:flex hidden">
          <img src={ICON_CORNER} alt="corner" width={8} height={8} className="kbv-corner-icon"/>
          <span className="text-sm font-semibold text-[var(--theme-text)]">{homeCorner}:{awayCorner}</span>
        </div>


        <div className="md:hidden flex items-baseline gap-1">
          <div>
            <span
              className={`text-sm text-[var(--theme-text)]${
                isHomeWin ? "font-bold" : ""
              }`}
            >
              {currentHomeScore}
            </span>
            :
            <span
              className={`text-sm text-[var(--theme-text)]${
                isAwayWin ? "font-bold" : ""
              }`}
            >
              {currentAwayScore}
            </span>
          </div>
        </div>
               
      </div>
    );
  }

  return null;
}